import { create } from 'zustand'

export interface DesktopIcon {
  id: string
  label: string
  icon: string
  appId: string
  position: { x: number; y: number }
}

interface DesktopState {
  icons: DesktopIcon[]
  selectedIcons: string[]
  startMenuOpen: boolean

  // Actions
  setStartMenuOpen: (open: boolean) => void
  toggleStartMenu: () => void
  selectIcon: (id: string) => void
  clearSelection: () => void
  moveIcon: (id: string, x: number, y: number) => void
}

const defaultIcons: DesktopIcon[] = [
  { id: 'about', label: 'About', icon: 'info', appId: 'about', position: { x: 20, y: 20 } },
  { id: 'products', label: 'Solutions', icon: 'cube', appId: 'products', position: { x: 20, y: 100 } },
  { id: 'terminal', label: 'Terminal', icon: 'terminal', appId: 'terminal', position: { x: 20, y: 180 } },
  { id: 'files', label: 'Files', icon: 'folder', appId: 'filemanager', position: { x: 20, y: 260 } },
  { id: 'calculator', label: 'Calc', icon: 'calculator', appId: 'calculator', position: { x: 20, y: 340 } },
  { id: 'notepad', label: 'Notepad', icon: 'file-text', appId: 'notepad', position: { x: 20, y: 420 } },
  { id: 'contact', label: 'Contact', icon: 'mail', appId: 'contact', position: { x: 120, y: 20 } },
  { id: 'minesweeper', label: 'Mines', icon: 'bomb', appId: 'minesweeper', position: { x: 120, y: 100 } },
  { id: 'worldmap', label: 'Map', icon: 'globe', appId: 'worldmap', position: { x: 120, y: 180 } },
  { id: 'oregon-trail', label: 'Oregon', icon: 'wagon', appId: 'oregon-trail', position: { x: 120, y: 260 } },
  { id: 'tradewars', label: 'TradeWars', icon: 'rocket', appId: 'tradewars', position: { x: 120, y: 340 } },
  { id: 'ai-assistant', label: 'AI Bot', icon: 'robot', appId: 'ai-assistant', position: { x: 120, y: 420 } },
  { id: 'zelda', label: 'Zelda', icon: 'sword', appId: 'zelda', position: { x: 220, y: 20 } },
  { id: 'solitaire', label: 'Solitaire', icon: 'cards', appId: 'solitaire', position: { x: 220, y: 100 } },
  { id: 'lord', label: 'LORD', icon: 'dragon', appId: 'lord', position: { x: 220, y: 180 } },
  { id: 'chess', label: 'Chess', icon: 'chess', appId: 'chess', position: { x: 220, y: 260 } },
]

export const useDesktopStore = create<DesktopState>((set) => ({
  icons: defaultIcons,
  selectedIcons: [],
  startMenuOpen: false,

  setStartMenuOpen: (open) => set({ startMenuOpen: open }),
  toggleStartMenu: () => set((state) => ({ startMenuOpen: !state.startMenuOpen })),

  selectIcon: (id) => set({ selectedIcons: [id] }),
  clearSelection: () => set({ selectedIcons: [] }),

  moveIcon: (id, x, y) =>
    set((state) => ({
      icons: state.icons.map((icon) =>
        icon.id === id ? { ...icon, position: { x, y } } : icon
      ),
    })),
}))
